import { StarPosition } from 'types/galaxy';

export const lerp = (start: number, end: number, t: number): number => {
  return start + (end - start) * t;
};

export const lerpPosition = (
  startPos: StarPosition,
  endPos: StarPosition,
  t: number
): StarPosition => {
  return {
    x: lerp(startPos.x, endPos.x, t),
    y: lerp(startPos.y, endPos.y, t),
    z: lerp(startPos.z, endPos.z, t),
  };
};

export const easeInOutCubic = (t: number): number => {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
};

export const easeInOutQuad = (t: number): number => {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
};

export const clamp = (value: number, min: number, max: number): number => {
  return Math.max(min, Math.min(max, value));
};
